import { useEffect } from 'react';

interface ClickData {
  elementId: string;
  timestamp: number;
  elementType: string;
  elementText?: string;
}

export const useClickTracker = () => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      
      // Function to find the closest element with an ID
      const findElementWithId = (element: HTMLElement | null, maxDepth = 3): string => {
        if (!element || maxDepth === 0) return 'unknown';
        
        if (element.tagName) return element.tagName.toLowerCase();
        
        return findElementWithId(element.parentElement, maxDepth - 1);
      };

      const elementId = findElementWithId(target);
      
      const clickData: ClickData = {
        elementId,
        timestamp: Date.now(),
        elementType: target.tagName.toLowerCase(),
        elementText: target.textContent?.trim() || ''
      };

      // Store only the last click data in sessionStorage
      sessionStorage.setItem('lastClickedElement', JSON.stringify(clickData));
    };

    // Add click event listener with capture phase
    document.addEventListener('click', handleClick, true);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, []);
}; 